import React from 'react';
import './About.css';

const About: React.FC = () => {
  return (
    <section id="about" className="about section-padding">
      <div className="container">
        <div className="section-header text-center mb-8">
          <h2 className="section-title">About F Square Contracting</h2>
          <p className="section-subtitle">
            Your trusted partner for professional electrical services across India
          </p>
        </div>

        <div className="about-content">
          <div className="about-text">
            <div className="about-intro">
              <h3>Trusted Provider of High-Quality Electrical Services</h3>
              <p>
                F Square Contracting is a trusted provider of high-quality electrical services
                in India, preferred by commercial, industrial and residential clients. Our team of trained electricians is dedicated to
                delivering exceptional service and expert solutions tailored to meet your specific needs.
              </p>
            </div>

            <div className="about-values">
              <h4>Our Core Commitments</h4>
              <div className="values-list">

                <div className="value-item">
                  <div className="value-icon">💯</div>
                  <div className="value-content">
                    <h5>Quality</h5>
                    <p>We strive for excellence in every aspect of our work, ensuring that our clients
                      receive the highest quality service and craftsmanship.</p>
                  </div>
                </div>
                <div className="value-item">
                  <div className="value-icon">🛡️</div>
                  <div className="value-content">
                    <h5>Safety</h5>
                    <p>The safety of our employees, clients, and the community is our top priority. We
                      adhere to strict safety protocols and standards on every job site.</p>
                  </div>
                </div>
                <div className="value-item">
                  <div className="value-icon">🔒</div>
                  <div className="value-content">
                    <h5>Reliability</h5>
                    <p>Our clients can rely on us to deliver on our promises, meet project deadlines,
                      and exceed expectations.</p>
                  </div>
                </div>
              </div>
            </div>

            {/* <div className="about-team">
              <h4>Expert Team of Professionals</h4>
              <p>
                Our success is built on the expertise of our team of trained electricians. 
                Each member of our team brings years of experience and specialized knowledge 
                to every project. We invest in continuous training and certification to ensure 
                our team stays current with the latest industry standards and technologies.
              </p>
            </div> */}
          </div>

          {/* <div className="about-contact-card">
            <h4>Get In Touch</h4>
            <div className="contact-info">
              <div className="contact-item">
                <div className="contact-icon">📍</div>
                <div className="contact-details">
                  <h5>Our Location</h5>
                  <p>
                    No. 183 184, 1st Floor, 9th street,<br />
                    Selliamman Nagar, Vellanoor Village,<br />
                    Arikkambedu, Chennai-600062
                  </p>
                </div>
              </div>
              
              <div className="contact-item">
                <div className="contact-icon">📞</div>
                <div className="contact-details">
                  <h5>Phone</h5>
                  <a href="tel:+918056177577">+91 80561 77577</a>
                </div>
              </div>
              
              <div className="contact-item">
                <div className="contact-icon">✉️</div>
                <div className="contact-details">
                  <h5>Email</h5>
                  <a href="mailto:info@fsquare.biz">info@fsquare.biz</a>
                </div>
              </div>
            </div>
            
            <div className="service-areas">
              <h5>Service Areas</h5>
              <div className="areas-grid">
                <span className="area-tag">Industrial</span>
                <span className="area-tag">Commercial</span>
                <span className="area-tag">Residential</span>
              </div>
            </div>
          </div> */}
        </div>

        {/* <div className="about-stats">
          <div className="stat-item">
            <span className="stat-number">3+</span>
            <span className="stat-label">Years of Experience</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">32+</span>
            <span className="stat-label">Projects Completed</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">100%</span>
            <span className="stat-label">Client Satisfaction</span>
          </div>         
        </div> */}
      </div>
    </section>
  );
};

export default About;
